import React, { useRef, useState } from "react"
import {
  PreviewWrapper,
  HeaderSection,
  HeadingContainer,
  HeadingTitle,
  ContentBody,
  ImageCardContainer,
  ImagePreviewWrapper,
  ImagePreview,
  BottomActions,
  RetakeTextContainer,
  RetakePromptText,
  RetakeButton,
  PhotoUploadingWrapper,
  HeadingDescription,
} from "./styled"
import CustomLoading from "components/loading/CustomLoading"
import { useLogMealStep, useScanMeal } from "features/meal/hooks"
import { useAppSelector } from "app/hooks"
import Button from "components/Buttons/Button"
import { useFailed, useSilentFailed } from "features/notification/hooks"
import { NotFoundDescription, NotFoundErrorText } from "../../share/styled"
import { FlexBox } from "components/Common/FlexBox"
import NotFoundIcon from "components/Icons/NotFoundIcon"

interface PreviewProps {
  previewImageUrl?: string
  isScanDisabled: boolean
}

const Preview: React.FC<PreviewProps> = ({
  previewImageUrl,
  isScanDisabled,
}) => {
  const { handleScanMeal } = useScanMeal()
  const handleSetStep = useLogMealStep()

  const processImageFailed = useAppSelector(
    (state) => state.meal.processImageFailed,
  )
  const processImageLoading = useAppSelector(
    (state) => state.meal.processImageLoading,
  )
  const [showProcessImageFailed, setShowProcessImageFailed] = useState(false)

  useSilentFailed(processImageFailed, () => {
    setShowProcessImageFailed(true)
  })

  const handleRetakePhoto = () => {
    handleSetStep("take-photo")
  }

  return (
    <PreviewWrapper>
      {/* Header with Title */}
      <HeaderSection>
        <HeadingContainer>
          <HeadingTitle>Photo Uploaded</HeadingTitle>
          <HeadingDescription>Preview your image.</HeadingDescription>
        </HeadingContainer>
      </HeaderSection>

      {/* Content Body */}
      <ContentBody>
          <ImageCardContainer>
            {processImageLoading ? (
              <PhotoUploadingWrapper>
                <CustomLoading />
              </PhotoUploadingWrapper>
            ) : showProcessImageFailed ? (
              <PhotoUploadingWrapper>
                <NotFoundIcon />
              </PhotoUploadingWrapper>
            ) : (
              <ImagePreviewWrapper>
                <ImagePreview src={previewImageUrl} alt="Uploaded meal" />
              </ImagePreviewWrapper>
            )}
          </ImageCardContainer>

          {showProcessImageFailed ? (
            <div>
              <NotFoundErrorText>Something went wrong.</NotFoundErrorText>
              <NotFoundDescription>Let’s try again.</NotFoundDescription>
              <Button
                disabled={processImageLoading || isScanDisabled}
                $borderLess
                style={{ width: 143, alignSelf: "center", marginTop: 16 }}
                onClick={handleRetakePhoto}
                $type="primary"
              >
                Retry
              </Button>
            </div>
          ) : (
            <Button
              disabled={processImageLoading || isScanDisabled}
              $borderLess
              style={{ width: 143, alignSelf: "center" }}
              onClick={handleScanMeal}
              $type="primary"
            >
              Submit
            </Button>
          )}
      </ContentBody>

      {/* Bottom Actions - Retake Photo */}
      {!showProcessImageFailed && (
        <BottomActions>
          <RetakeTextContainer>
            <RetakePromptText>Take a better photo?</RetakePromptText>
            <RetakeButton onClick={handleRetakePhoto}>
              Retake Photo
            </RetakeButton>
          </RetakeTextContainer>
        </BottomActions>
      )}
    </PreviewWrapper>
  )
}

export default Preview
